declare namespace $ {

	export class $shm_hitalama_map_widget_float_ai_request_form extends $mol_view {
		Widget( ): $shm_hitalama_map_widget_float_ai_request
		text( ): string
		prompt( ): string
		paste( ): any
		next_request( ): any
		next_request_type( ): string
	}
	
}

//# sourceMappingURL=form.view.tree.d.ts.map